import { TransactionEntrySplitInput } from '../../graphql/generated';
import { TransactionEntryTag } from './types';

export interface TransactionEntrySplit extends TransactionEntrySplitInput {
    isExpanded: boolean;
    // Needed on mobile so we can render the correct tag color
    tags: TransactionEntryTag[];
}

export const createSplit = ({
    categoryId,
    merchantId,
    amount,
    isExpanded,
}: Pick<TransactionEntrySplit, 'categoryId' | 'merchantId' | 'amount'> & {
    isExpanded: boolean;
}): TransactionEntrySplit => ({
    categoryId,
    merchantId,
    amount,
    tagNames: [],
    tags: [],
    isHidden: false,
    isExpanded,
});
